import { useEffect, useState } from 'react'
import { areResultsAvailable, RESULTS_AVAILABLE_TIMESTAMP } from '@/app/electionSchedule'

export function useResultsAvailable() {
  const [available, setAvailable] = useState(areResultsAvailable)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    function check() {
      clearTimeout(timer)
      const next = areResultsAvailable()
      setAvailable(next)
      // Recheck long waits to stay below the browser's maximum timeout.
      if (!next) timer = setTimeout(check, Math.min(RESULTS_AVAILABLE_TIMESTAMP - Date.now(), 60_000))
    }
    check()
    window.addEventListener('focus', check)
    document.addEventListener('visibilitychange', check)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('focus', check)
      document.removeEventListener('visibilitychange', check)
    }
  }, [])

  return available
}
